(function ($) {
  // Document Ready
  $(document).ready(function () {
    if ($(".owl-carousel").length) {
      console.log("carousels.js initiated");
    }

    // Tours Carousel
    $(".tours-carousel .owl-carousel").each(function () {
      var $carousel = $(this);
      var $navContainer = $carousel.closest(".tours-carousel").find(".carousel-nav");
      $carousel.owlCarousel({
        loop: true,
        autoplay: false,
        autoHeight: false,
        items: 4.1,
        dots: false,
        nav: true,
        navContainer: $navContainer.length ? $navContainer : false,
        mouseDrag: true,
        touchDrag: true,
        navText: [
          '<span class="visuallyhidden">Click to view the previous</span><svg xmlns="http://www.w3.org/2000/svg" width="14.121" height="25.243" viewBox="0 0 14.121 25.243"><path d="M16.5,7.5,6,18,16.5,28.5M6,18" transform="translate(-4.5 -5.379)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>',
          '<span class="visuallyhidden">Click to view the next</span><svg xmlns="http://www.w3.org/2000/svg" width="14.121" height="25.243" viewBox="0 0 14.121 25.243"><path d="M10.5,0,0,10.5,10.5,21M0,10.5" transform="translate(12.621 23.121) rotate(180)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>',
        ],
      });

      var isAnimating = false;
      var deltaThreshold = 10; // Increase this value for less sensitivity

      $carousel.on("mousewheel", ".owl-stage", function (e) {
        // Horizontal scroll
        if (Math.abs(e.deltaX) > deltaThreshold) {
          e.preventDefault();
          if (isAnimating) {
            return;
          }
          isAnimating = true;

          if (e.deltaX > 0) {
            $carousel.trigger("next.owl.carousel");
          } else {
            $carousel.trigger("prev.owl.carousel");
          }
        }
      });

      $carousel.on("translated.owl.carousel", function () {
        isAnimating = false;
      });
    });
    // END – Tours Carousel

    // Add-Ons Carousel
    $(".add-ons-section .owl-carousel").each(function () {
      var $carousel = $(this);
      var $section = $carousel.closest(".add-ons-section");
      var $counter = $section.find(".count-number-first");
      var $total = $section.find(".count-number-total");
      var totalSlides = $carousel.find(".image-item").length;

      // Initialize carousel
      $carousel.owlCarousel({
        autoplay: false,
        autoHeight: true,
        items: 1,
        dots: false,
        nav: true,
        rewind: true,
        navText: [
          '<span class="visuallyhidden">Click to view the previous</span><svg xmlns="http://www.w3.org/2000/svg" width="38.947" height="38.947" viewBox="0 0 38.947 38.947"><path d="M32.3,9,9,32.3M12.883,9H32.3V28.414" transform="translate(19.473 48.675) rotate(-135)" fill="none" stroke="#ebeaf9" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>',
          '<span class="visuallyhidden">Click to view the next</span><svg xmlns="http://www.w3.org/2000/svg" width="38.947" height="38.947" viewBox="0 0 38.947 38.947"><path d="M32.3,9,9,32.3M12.883,9H32.3V28.414" transform="translate(19.473 -9.728) rotate(45)" fill="none" stroke="#ebeaf9" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>',
        ],
        onInitialized: function () {
          // Set initial counter values
          $counter.text("1");
          $total.text(totalSlides);
        },
        onTranslated: function (event) {
          // Update counter when slide changes
          var currentIndex = event.item.index + 1;
          $counter.text(currentIndex);
        },
      });
    });
    // END – Add-Ons Carousel
  });
})(jQuery);
